import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-casino-promotion',
  templateUrl: './casino-promotion.component.html',
  styleUrls: ['./casino-promotion.component.css']
})
export class CasinoPromotionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/casino-promotion/casino-promotion.component.ts